// extracted by mini-css-extract-plugin
module.exports = {"renewing":"BraintreePlanTable_renewing__dLr_W","status":"BraintreePlanTable_status__3KFKj","table":"BraintreePlanTable_table__gCiSP"};